import './Header.scss'
import React, { useState, useRef } from 'react'
import { withRouter } from 'react-router-dom'

import { Translated } from '../../utils/translated'
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher'
import { ReactComponent as LogoGradient } from './images/logo_gradient.svg'
import { ReactComponent as LogoWhite } from './images/logo_white.svg'
import { ReactComponent as BurgerSVG } from './images/menu_burger.svg'
import { ReactComponent as CrossSVG } from './images/menu_cross.svg'
import useOutsideClick from './useOutsideClick'

const Header = (props) => {

    const [isCollapse, setIsCollapse] = useState(null);
    const [active, setActive] = useState(-1);
    const ref = useRef();

    switch (props.history.location.pathname) {
        case '/select-auth':
        case '/auth-dots-maze':
        case '/auth-scale-emotions':
            active !== 0 && setActive(0); break;
        case '/select-onboarding':
        case '/onboarding-scale-emotions':
        case '/onboarding-dots-maze':
        case '/onboarding2':
            active !== 1 && setActive(1); break;
        case '/feature':
        case '/feature/matching':
        case '/feature/liveness':
        case '/feature/register1':
        case '/feature/register2':
        case '/feature/register3':
        case '/feature/login1':
        case '/feature/login2':
        case '/feature/login3':
        case '/feature/login4':
        case '/feature/login5':
        case '/feature/login6':
        case '/feature/document':
            active !== 2 && setActive(2); break;
        default:
            active !== -1 && setActive(-1); break;
    }

    useOutsideClick(ref, () => {
        isCollapse && setIsCollapse(!isCollapse);
    });

    const Logo = (props) => isCollapse
        ? <LogoWhite {...props} />
        : <LogoGradient {...props} />

    return (
        <header ref={ref} className={isCollapse === true ? 'open' : isCollapse === false ? 'close' : null}>
            <Logo
                width={136}
                height={27}
                onClick={() => {
                    setIsCollapse(false);
                    props.history.push('/');
                }} />

            <div className='btn-group'>
                <button className='btn-gradient' onClick={() => window.location.href = 'https://svort.io'}>
                    <Translated id='app.header.main-site' />
                </button>

                <LanguageSwitcher />

                <div className='space'></div>

                <div className='hr'></div>

                <button className={active === 2 ? 'active' : null}
                    onClick={() => {
                        setIsCollapse(false);
                        props.history.push('/feature');
                    }}>
                    <Translated id='app.header.features' />
                </button>

                <div className='hr'></div>

                <button className={active === 1 ? 'active' : null}
                    onClick={() => {
                        setIsCollapse(false);
                        props.history.push('/select-onboarding');
                    }}>
                    <Translated id='app.header.onboarding' />
                </button>

                <div className='hr'></div>

                <button className={active === 0 ? 'active' : null}
                    onClick={() => {
                        setIsCollapse(false);
                        props.history.push('/select-auth')
                    }}>
                    <Translated id='app.header.authentication' />
                </button>

                <div className='hr'></div>

                <button className='icon' onClick={() => setIsCollapse(!isCollapse)}>
                    {isCollapse ? <CrossSVG /> : <BurgerSVG />}
                </button>
            </div>
        </header>
    )
}

export default withRouter(Header)